import { observable, action, runInAction } from 'mobx';
import { isEmpty } from 'lodash';

const moTop = observable({
  companyCount: <number | string>'',
  amountChange: <number | string>'',
  salaryChange: <number | string>'',
  updateTime: '',
});

const onPlay = action(() => {
  console.log('play...');
});

const initOverview = action((res: any) => {
  if (isEmpty(res)) return;

  moTop.amountChange = res.amount_change;
  moTop.companyCount = res.company_count;
  moTop.salaryChange = res.salary_change;
});

const initUpdateTime = action((res: any) => {
  if (isEmpty(res)) return;
  moTop.updateTime = res.HRIndicator || '';
});

export default moTop;
export { onPlay, initOverview, initUpdateTime };
